module.exports = __webpack_public_path__ + "static/media/rapido-green-overlay.b1c76943.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/rapido-green-overlay.jpg
// module id = 566
// module chunks = 0